import {
    addHost,
    getClockTimer,
    formatDate,
    getDateDiff,
    getDateTimer,
    getLimitedStr,
    formatCount,
    formatCreateTime,
} from '@kk-activity-factory/utils';

const filters = {
    addHost,
    getClockTimer,
    formatDate,
    getDateDiff,
    getDateTimer,
    getLimitedStr,
    formatCount,
    formatCreateTime,
};

export default filters;
